import { LEVEL_NAMES } from '../lib/oura';
import { cn } from '../lib/cn';

/** Five rungs, low to high. The current level is filled; the rest are muted. */
export function LevelLadder({ level }: { level: number | null }) {
  return (
    <div className="flex flex-col gap-1.5">
      {[5, 4, 3, 2, 1].map((rung) => {
        const active = level === rung;
        const reached = level !== null && rung <= level;
        return (
          <div key={rung} className="flex items-center gap-3">
            <div
              className={cn(
                'h-2 flex-1 rounded-full',
                reached ? 'bg-blue-500' : 'bg-gray-200',
              )}
            />
            <span
              className={cn(
                'w-28 text-right text-xs',
                active ? 'font-semibold text-gray-900' : 'text-gray-400',
              )}
            >
              {LEVEL_NAMES[rung - 1]}
            </span>
          </div>
        );
      })}
    </div>
  );
}
